import { FocusTrap, Group, Space, Checkbox, Card, Text, ColorSwatch } from "@mantine/core";
import { useMemo } from "react";

interface Fase {
  id: string;
  titulo: string;
  cor: string;
  checked?: boolean;
  // status: Status[];
}
// prettier-ignore
const FaseForm = ({ fases, setFases, checkeds }: { fases: Fase[]; setFases: React.Dispatch<React.SetStateAction<Fase[]>>, checkeds: Fase[] }) => {
  const checkedIds = useMemo(() => new Set(checkeds.map((item) => item.id)), [checkeds]);
  const toggleHandlers = useMemo(() => {
    const handlers = new Map<string, () => void>();
    for (const fase of fases) {
      handlers.set(fase.id, () => {
        setFases((previous) =>
          previous.some(item => item.id === fase.id)
            ? previous.filter(item => item.id !== fase.id)
            : [...previous, { ...fase, checked: true }]
        );
      });
    }
    return handlers;
  }, [fases, setFases]);

  return (
    <FocusTrap active={true}>
      {ordenarArray(fases)?.map((fase: Fase) => (
        <>
          <Card withBorder radius="md">
            <Group justify={"space-between"}>
              <Group align={"center"}>
                <ColorSwatch color={fase.cor} />
                <Text>{fase.titulo}</Text>
              </Group>
              {fase.checked || fase.id === "1" || fase.id === "7" ? <></> : <Checkbox onChange={toggleHandlers.get(fase.id)} checked={checkedIds.has(fase.id)} />}
            </Group>
          </Card>
          <Space h="md" />
        </>
      ))}
    </FocusTrap>
  );
};

export default FaseForm;

/**
 * Ordena o array para que o item com o título "Inscrição" seja o primeiro
 * e o item com o título "Vencedores" seja o último. Os demais itens
 * mantêm a ordem relativa entre si.
 * @param array - O array de objetos a ser ordenado.
 * @returns - O array ordenado.
 */
function ordenarArray(array: Fase[]) {
  return array.sort((a, b) => {
    if (a.titulo === "Inscrição") return -1;
    if (b.titulo === "Inscrição") return 1;

    if (a.titulo === "Vencedores") return 1;
    if (b.titulo === "Vencedores") return -1;

    return 0;
  });
}
